// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"e_2g","content":"e_3g","container":"e_4g"};